module.exports = __webpack_public_path__ + "img/img11.3f083877.png";